import PathRefEditor from './PathRefEditor.vue'
export default {
  install: function (Vue) {
    Vue.component('path-ref-editor', PathRefEditor)
  }
}